import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { ClientOrderFee } from "../../../models/entities/ClientOrder/ClientOrderFee";
import { CustomHttpResponse } from "../../../models/data/CustomHttpResponse";

@Injectable({
  providedIn: 'root',
})
export class ClientOrderFeeService {
  apiService: ApiHttpService<ClientOrderFee> = inject(ApiHttpService<ClientOrderFee>);

  getClientOrderFeeByIri(iri: string): Observable<ClientOrderFee> {
    return this.apiService.get(iri).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientOrderFee>) => result.body),
    );
  }

  getClientOrderFeeById(id: string): Observable<ClientOrderFee> {
    return this.apiService.get(`/client_order_fees/${id}`).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientOrderFee>) => result.body),
    );
  }

  createClientOrderFee(ClientOrderFee: ClientOrderFee): Observable<ClientOrderFee> {
    return this.apiService
      .post(`/client_order_fees`, ClientOrderFee)
      .pipe(map((result: CustomHttpResponse<ClientOrderFee>) => result.body));
  }

  getClientOrderFeesForClientOrder(iri: string): Observable<ClientOrderFee[]> {
    return this.apiService.getMany(`${iri}/client_order_fees`).pipe(map((result) => result.body['hydra:member']));
  }

  updateClientOrderFee(
    iri: string,
    updatedRecord: Record<string, string | number | null | undefined>,
  ): Observable<ClientOrderFee> {
    return this.apiService.patch(iri, updatedRecord as unknown as ClientOrderFee).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientOrderFee>) => result.body),
    );
  }

  delete(iri: string) {
    return this.apiService.delete(iri).pipe(map((result) => result));
  }
}
